<nav *ngIf="appUser && appUser.groupAdmin">
        <div class="input-group input-group-sm">
            <input type="text" name="searchString" maxlength="30" class="form-control border-success" id="discussionSearchBox" placeholder="search discussions" value="{{searchString}}" data-toggle="tooltip" title="Free text search" aria-label="search" aria-describedby="basic-addon2"/>
            <div class="input-group-append">
              <button class="btn btn-outline-success searchBtn"  disabled="disabled"><i class="fa fa-search" aria-hidden="true"></i></button>
            </div>
        </div>
</nav>